// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"7fab0339","488":"4a85587a"}[chunkId] + ".chunk.js";
};